import { TrendingUp, Clock, Target, DollarSign } from "lucide-react";

const stats = [
  {
    icon: TrendingUp,
    value: "40%",
    label: "Higher Close Rate",
    description: "AI-powered insights",
  },
  {
    icon: Clock,
    value: "3hr",
    label: "Saved Daily",
    description: "Per rep automation",
  },
  {
    icon: Target,
    value: "92%",
    label: "Score Accuracy",
    description: "ML predictions",
  },
  {
    icon: DollarSign,
    value: "2.5x",
    label: "Faster Cycles",
    description: "Lead to close",
  },
];

export function HeroStats() {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 max-w-3xl mx-auto">
      {stats.map((stat, index) => (
        <div
          key={stat.label}
          className="glass rounded-lg p-4 text-center group hover:border-primary/30 hover-lift transition-all duration-300"
          style={{ animationDelay: `${index * 100}ms` }}
        >
          <div className="inline-flex p-2 rounded-lg bg-primary/10 mb-2 group-hover:ai-glow-subtle transition-all duration-300">
            <stat.icon className="h-4 w-4 text-primary" />
          </div>
          <p className="text-2xl font-bold text-primary mb-0.5">{stat.value}</p>
          <p className="font-medium text-foreground text-sm mb-0.5">{stat.label}</p>
          <p className="text-xs text-muted-foreground">{stat.description}</p>
        </div>
      ))}
    </div>
  );
}
